import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface AccordionItem {
  id: string;
  question: string;
  answer: string;
  category?: string;
}

interface AccordionProps {
  items: AccordionItem[];
  groupedByCategory?: boolean;
}

export default function Accordion({ items, groupedByCategory = false }: AccordionProps) {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleItem = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  if (groupedByCategory) {
    const categories = Array.from(new Set(items.map(item => item.category).filter(Boolean)));
    return (
      <div className="space-y-8">
        {categories.map((category) => (
          <div key={category}>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">{category}</h3>
            <div className="space-y-4">
              {items
                .filter(item => item.category === category)
                .map((item) => (
                  <div key={item.id} className="border border-gray-200 rounded-xl overflow-hidden">
                    <button
                      className="w-full px-6 py-4 text-left flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors"
                      onClick={() => toggleItem(item.id)}
                    >
                      <span className="font-semibold text-gray-900">{item.question}</span>
                      {openId === item.id ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </button>
                    {openId === item.id && (
                      <div className="px-6 py-4 bg-white">
                        <p className="text-gray-700">{item.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <div key={item.id} className="border border-gray-200 rounded-xl overflow-hidden">
          <button
            className="w-full px-6 py-4 text-left flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors"
            onClick={() => toggleItem(item.id)}
          >
            <span className="font-semibold text-gray-900">{item.question}</span>
            {openId === item.id ? (
              <ChevronUp className="h-5 w-5 text-gray-500" />
            ) : (
              <ChevronDown className="h-5 w-5 text-gray-500" />
            )}
          </button>
          {openId === item.id && (
            <div className="px-6 py-4 bg-white">
              <p className="text-gray-700">{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}